import styled from 'styled-components';
import React from 'react';

import { Button } from 'shared/components';

const TEST_ID_PUBLISH_BANNER_CONTAINER = 'publish-banner-container';

export function PublishBanner(props) {
  const { onPublish, onPublishToAll, headerText, shouldShowPublishToAll } = props;
  const [loading, setLoading] = React.useState(false);

  const subText = headerText
    ? `Publish these ${headerText} changes to display them to customers on Dutchie.`
    : `To publish these changes and display them to customers on dutchie, click "publish".`;

  async function handlePublish() {
    setLoading(true);
    await onPublish();
    setLoading(false);
  }

  return (
    <Container data-testid={TEST_ID_PUBLISH_BANNER_CONTAINER}>
      <Description>
        <Heading>Unpublished Changes</Heading>
        <Subheading>{subText}</Subheading>
      </Description>

      <ButtonContainer>
        <Button loading={loading} onClick={handlePublish}>
          Publish
        </Button>

        {shouldShowPublishToAll && (
          <Button loading={loading} onClick={onPublishToAll} inverted>
            Publish to all locations
          </Button>
        )}
      </ButtonContainer>
    </Container>
  );
}

const Container = styled.div`
  align-items: center;
  background: #fffbd6;
  border-radius: 0 0 9px 0;
  border-width: 1px 1px 0 0;
  border: 1px solid #d4cc99;
  display: flex;
  justify-content: space-between;
  margin: -1px;
  padding: 16px;
  position: sticky;
  bottom: 0;
`;

const Description = styled.div`
  flex: 1 0 0%;
  min-width: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
  min-width: 0;
`;

const Heading = styled.div`
  color: #767359;
  font-size: 16px;
  font-weight: bold;
  line-height: 19px;
  margin-bottom: 4px;
`;

const Subheading = styled.div`
  color: #4f5d68;
  font-size: 12px;
  line-height: 20px;
`;
